<div class="oidc-callback">
  <p class="oidc-callback-text">Signing you in…</p>
  <div class="dots" aria-hidden="true">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</div>
